module.exports = __webpack_public_path__ + "img/level2addon_idle_gun_shadow.5bb92516.png";